import React from 'react';
import device from '../../../services/mini/device';

export function RoundExpandableButton({
    children,
    label,
    className,
    disabled,
    expanded,
    onClick,
    value,
    saving
}) {

    return <div className={`round-expandable-button ${value && 'has-value'} ${disabled && 'disabled'}`}>
        <div
            className={`round-expandable-button_content ${className} ${expanded && 'expanded'} ${device.isDesktop() && 'desktop'} ${saving && 'saving'}`}
            onClick={onClick}>
            {children}<div className="round-expandable-button_label">{label}</div>
        </div>
        <i className={`icon icon-checkbox-small ${!!value && 'visible-with-opacity'}`} />
    </div>;

}
